  /**
   * ScrollAnimations
   * This class by Riot based on NeedNap code (originally for gsap2) uses gsap3 and scrolltrigger to map animations to dom elements using data-anim attribute
   * https://greensock.com/docs/v3/Plugins/ScrollTrigger
   */

   import {gsap, CSSPlugin, Power3, Power2, Power0} from 'gsap';
   import { ScrollTrigger } from "gsap/ScrollTrigger";
   import { css } from 'jquery';
   gsap.registerPlugin(ScrollTrigger);

   class ScrollAnimations {


     constructor() {
       this.$window = $(window);

       this.defaultAnimationConfig = [
         'fadeIn',   //0 - Gsap animation type,
         0.5,        //1 -  Gsap animation duration (seconds)
         0.2,        //2 - Gsap animation delay
         0,          //3 - Gsap Initial Alpha, set to 1 to disable fade in
         0,          //4 - Gsap distance
         false,      //5 -  ScrollTrigger scrub. false for non scrubbable animation, 0 to 1.6 for scrubbing with delay (seconds)
         80,         //6 - ScrollTrigger "start" offset (second value), in percentage from top of page
         0,          //7 - unused
         0,          //8 - unused
       ];

       this.initAnimations();
     }


     initAnimations() {

       this.initialWidth = $(window).width(),
       this.initialHeight = $(window).height();
       let slideDistance = (0.01 * this.initialWidth );
       this.scenes = [];

       //specific and unique scrollmagic scenes
       // home hero parallax

       // if( $('.hero-home').length ) {
       // }


       $('[data-anim]').each((index, element) => {

         let $element = $(element);

         let config = this.getAnimationConfig($element);

         const myTimeline = gsap.timeline({ paused: true })

         switch (config[0]) {
            case 'zoomIn':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], scale:0.7, y: "-5px"}, {autoAlpha: 1, scale:1, y: 0, delay: config[2]});
             break;
           case 'zoomInBg':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], scale:1 }, {autoAlpha: 1, scale:1.1, delay: config[2], ease: Power2.easeOut});
             break;

            case 'blurOutBg':
              myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], scale:1.4,  css:{filter:"blur(50px)", transform:"scale(1.2)", opacity:0}, autoRound: false }, {autoAlpha: 1, scale:1.0,  css:{filter:"blur(0px)", transform:"scale(1)", opacity: 1}, autoRound: false, delay: config[2], ease: Power2.easeOut});
              break;

           case 'fadeInLeft':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], x: "-" + this.windowWidthToPixel() + config[4] }, {autoAlpha: 1, x: 0, delay: config[2], ease: Power2.easeOut});
             break;

           case 'fadeInRight':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], x: this.windowWidthToPixel() + config[4] }, {autoAlpha: 1, x: 0, delay: config[2], ease: Power2.easeOut});
             break;

           case 'fadeInUp':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], y:  this.windowWidthToPixel()  + config[4]}, {duration: config[1], autoAlpha: 1, y: 0, delay: config[2], ease: Power2.easeOut});
             break;

           case 'parallaxInUp':
               myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], y:  this.windowWidthToPixel()  + config[4]}, {autoAlpha: 1, y: 0, delay: config[2]});
               break;

           case 'rotateInUp':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], rotation: 45, y:  this.windowWidthToPixel()  + config[4]}, {autoAlpha: 1, y: 0, rotation: 0, delay: config[2]});
             console.log(config[4]);
             break;


           case 'fadeInDown':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: config[3], y: "-" + this.windowWidthToPixel()  + config[4]}, {autoAlpha: 1, y: 0, delay: config[2], ease: Power2.easeOut});
             break;
           case '':
           case 'fadeIn':
             myTimeline.fromTo($element, {duration: config[1], autoAlpha: 0}, {autoAlpha: 1, delay: config[2], ease: Power0.linear});
             break;
           default:
             /* eslint-disable-next-line no-console */
             console.error('AnimationConfig type "' + config[0] + '" not valid');
             break;
         }



         ScrollTrigger.create({
           //id: $element + "-scrolling",  //this scrolltrigger ID to call it elsewhere
           trigger: $element,
           scrub: config[5], // scrub with delay
           start: "top 100%", // [$element] [viewport position]
           toggleActions: "play pause resume reset", // default: play none none none
           end: "100%",
           animation: myTimeline,
           onToggle: self => {
             //console.log("toggled, isActive:", self.isActive);
             //console.log("toggled, config 6:" + this.class + " " + config[6]);
             //config[6]
           },
           onUpdate: self => {
             //console.log($element);
           }
         });

       });


     } //  end of initAnimations()


     //allows for animations proportional to window width
     windowWidthToPixel(){

         let $size = 0.03 * $(window).width();
         //console.log($size);
         return $size;

     }

     onResize(event) {


     }

     /**
      * return animation config array extended from default
      *
      * @param $element
      * @return {*[]}
      */
     getAnimationConfig($element) {

       let config = this.defaultAnimationConfig.slice(0); // clone the contents of array

       $.each($element.data('anim').split(' '), (index, value) => {
         try {
           if(index > config.length - 1)
             throw 'AnimationConfig index [' + index + '] "' + value + '" out of range';

           switch (index) {
             // parse float
             case 1:
             case 2:
             case 3:
             case 4:
             case 5:
             case 6:
               if(!value.match(/^([0-9]*[.])?[0-9]+$/))
                 throw 'AnimationConfig value at index['+ index +'] "' + value + '" is not a valid number';


               value = parseFloat(value);
               break;
           }

           config[index] = value;
         } catch (e) {
           /* eslint-disable-next-line no-console */
           console.error(e);
         }
       });

       return config;
     }

   }

   export default ScrollAnimations
